<template>
    <div class="shouru-tongji">
        <!-- 收入统计表格 -->
        <div class="table-card">
            <div class="card-header">
                <div class="header-left">
                    <div class="header-title">收入明细</div>
                    <!-- 彩种切换 -->
                    <div class="lottery_menu">
                        <div v-for="(item, index) in lottery.arr" :key="index"
                            :class="{ active: lottery.active == index }" @click="toggle_income_statistics(item, index)">
                            {{ item.label }}
                        </div>
                    </div>
                </div>
            </div>
            <el-table :data="tableData" border style="width: 100%"
                :header-cell-style="{ color: '#ffffff', backgroundColor: '#409eff', fontWeight: '600', padding: '5px 0' }">
                <el-table-column type="index" label="序号" width="60" />
                <el-table-column prop="number" label="购买期数" show-overflow-tooltip />
                <el-table-column prop="indexTypeName" label="购买指标类型" width="120" show-overflow-tooltip />
                <el-table-column label="指标准确率" width="120">
                    <template slot-scope="scope">
                        <span style="color: #10b981; font-weight: 500;">
                            {{ scope.row.backNumber }}中{{ scope.row.courrtNum }}期
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="价格" width="100">
                    <template slot-scope="scope">
                        <span style="color: #E92728; font-weight: 500;">
                            {{ scope.row.coin }}缩币
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="buyNum" label="认购次数" width="100" />
                <el-table-column prop="sumCoin" label="单个指标卖出缩币总额" show-overflow-tooltip width="170" />
                <el-table-column prop="commissionRate" label="当前阶梯提成比例" width="140">
                    <template slot-scope="scope">
                        <span style="color: #f59e0b; font-weight: 500;">
                            {{ scope.row.rate * 100 || 0 }}%
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="sumCommossionMoney" label="缩水师当期人民币收入(元)" width="190" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span style="color: #10b981; font-weight: 600;">
                            {{ scope.row.sumCommossionMoney }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="accumulateMoney" label="缩水师累计收入(元)" show-overflow-tooltip width="170">
                    <template slot-scope="scope">
                        <span style="color: #E92728; font-weight: 600;">
                            {{ scope.row.accumulateMoney }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <hxlPagin :queryParams="tableDataParams" @changePage="changePage($event, 'tableData')" />
        </div>

        <!-- 提成阶梯方案 -->
        <div class="scheme-card">
            <div class="card-header">
                <div class="header-title">缩水网提成阶梯执行方案</div>
            </div>

            <!-- 缩水师 -->
            <template v-if="tc_rule.sss.arr.length">
                <div class="sub-table-title">
                    <span class="title-tag sss">缩水师</span>
                </div>
                <el-table :data="tc_rule.sss.arr" border style="width: 100%"
                    :header-cell-style="{ color: '#ffffff', backgroundColor: '#409eff', fontWeight: '600', textAlign: 'center', padding: '5px 0' }"
                    :cell-style="{ textAlign: 'center', padding: '5px 0' }">
                    <el-table-column label="彩种" width="120">
                        <template slot-scope="scope">
                            {{
                                scope.row.ticketType == 0 ? '双色球' :
                                    scope.row.ticketType == 1 ? '大乐透' :
                                        scope.row.ticketType == 2 ? '福彩3D' :
                                            scope.row.ticketType == 3 ? '排列三' : ''
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column label="单个彩种单期总销售额" prop="title" show-overflow-tooltip />
                    <el-table-column label="比例" prop="comRate" width="100">
                        <template slot-scope="scope">
                            <span style="color: #409eff; font-weight: 500;">
                                {{ scope.row.comRate * 100 || 0 }}%
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <hxlPagin :queryParams="tc_rule.sss.queryParams" teacherType="sss" @changePage="changePage" />
            </template>

            <!-- 技巧师 -->
            <template v-if="tc_rule.jqs.arr.length">
                <div class="sub-table-title">
                    <span class="title-tag jqs">技巧师</span>
                </div>
                <el-table :data="tc_rule.jqs.arr" border style="width: 100%"
                    :header-cell-style="{ color: '#ffffff', backgroundColor: '#f59e0b', fontWeight: '600', textAlign: 'center', padding: '5px 0' }"
                    :cell-style="{ textAlign: 'center', padding: '5px 0' }">
                    <el-table-column label="彩种" width="120">
                        <template slot-scope="scope">
                            {{
                                scope.row.ticketType == 0 ? '双色球' :
                                    scope.row.ticketType == 1 ? '大乐透' :
                                        scope.row.ticketType == 2 ? '福彩3D' :
                                            scope.row.ticketType == 3 ? '排列三' : ''
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column label="单个彩种单期总销售额" prop="title" show-overflow-tooltip />
                    <el-table-column label="比例" prop="comRate" width="100">
                        <template slot-scope="scope">
                            <span style="color: #f59e0b; font-weight: 500;">
                                {{ scope.row.comRate * 100 || 0 }}%
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <hxlPagin :queryParams="tc_rule.jqs.queryParams" teacherType="jqs" @changePage="changePage" />
            </template>

            <!-- 软件师 -->
            <template v-if="tc_rule.rjs.arr.length">
                <div class="sub-table-title">
                    <span class="title-tag rjs">软件师</span>
                </div>
                <el-table :data="tc_rule.rjs.arr" border style="width: 100%"
                    :header-cell-style="{ color: '#ffffff', backgroundColor: '#10b981', fontWeight: '600', textAlign: 'center', padding: '5px 0' }"
                    :cell-style="{ textAlign: 'center', padding: '5px 0' }">
                    <el-table-column label="彩种" width="120">
                        <template slot-scope="scope">
                            {{
                                scope.row.ticketType == 0 ? '双色球' :
                                    scope.row.ticketType == 1 ? '大乐透' :
                                        scope.row.ticketType == 2 ? '福彩3D' :
                                            scope.row.ticketType == 3 ? '排列三' : ''
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column label="单个彩种单期总销售额" prop="title" show-overflow-tooltip />
                    <el-table-column label="比例" prop="comRate" width="100">
                        <template slot-scope="scope">
                            <span style="color: #10b981; font-weight: 500;">
                                {{ scope.row.comRate * 100 || 0 }}%
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <hxlPagin :queryParams="tc_rule.rjs.queryParams" teacherType="rjs" @changePage="changePage" />
            </template>
        </div>
    </div>
</template>

<script>
import qs from "qs";
import { incomeRecord } from "@/api/personalCenter";

import hxlPagin from "@/components/hxlPagin";
export default {
    components: { hxlPagin },
    data() {
        return {
            teacherType: [],

            lottery: {
                arr: [],
                active: "",
            },
            form: {
                time: "",
            },

            tableData: [],
            tableDataTotal: [],
            tableDataParams: {
                type: 0,
                pageNum: 1,
                pageSize: 10,
                total: 0
            },

            // 提成规则
            tc_rule: {
                sss: {
                    arr: [],
                    queryParams: {
                        pageNum: 1,
                        pageSize: 10,
                        total: 0,
                    },
                },
                jqs: {
                    arr: [],
                    queryParams: {
                        pageNum: 1,
                        pageSize: 10,
                        total: 0,
                    },
                },
                rjs: {
                    arr: [],
                    queryParams: {
                        pageNum: 1,
                        pageSize: 10,
                        total: 0,
                    },
                },
            },
        };
    },
    async mounted() {
        this.get_lottery_type()
        this.get_income_statistics()

        this.getList();

        let pre_type = await this.$utils.getDictionary("pre_type");

        // 查找师种
        this.$utils.getDictionary("pre_product_model").then((res) => {
            res.data.forEach((item) => {
                item.remark = JSON.parse(item.remark);
                item = JSON.parse(JSON.stringify(item, ["dictLabel", "dictValue", "remark", "status"]));
            });
            this.teacherType = res.data

            let teacherType = [
                { label: '缩水师', key: 'sss' },
                { label: '技巧师', key: 'jqs' },
                { label: '软件师', key: 'rjs' },
            ]
            teacherType.forEach((item) => {
                this.getCommission_rules({
                    label: item.label,
                    value: this.queryTeacher(item.label),
                    key: item.key,
                });
            });
        });
    },
    methods: {
        // 切换收入统计彩种
        toggle_income_statistics(item, index) {
            console.log('item', JSON.parse(JSON.stringify(item)));
            this.lottery.active = index
            this.tableDataParams.type = item.value
            this.get_income_statistics()
        },
        // 获取彩种种类
        get_lottery_type() {
            this.$http.get('/stage-api/pre/dict/lottery-type', {
                dictLabel: 'pre_type',
            }).then(res => {
                let rows = res.data;
                console.log('pre_type', res.data);
                this.lottery.arr = rows.map(item => {
                    return { value: item.dictValue, label: item.dictLabel };
                });
            });
        },

        // 获取收入统计数据
        get_income_statistics() {
            this.$http.get('/stage-api/recharge/income-record', {
                params: this.tableDataParams
            }).then(res => {
                console.log('income-record', JSON.parse(JSON.stringify(res.data.rows)));
                let { rows, total } = res.data;
                this.tableData = rows;
                this.tableDataParams.total = total;
            })
        },

        // 查找师种
        queryTeacher(type) {
            return this.teacherType.filter(item => item.remark.alias == type)[0].dictValue
        },

        getList() {
            incomeRecord().then((res) => {
                let { rows, total } = res.data;
                this.tableData = rows;
            });
        },

        // 获取彩种规则
        getCommission_rules(moduleType) {
            let { label, value, key } = moduleType

            this.tc_rule[key].queryParams.model = value
            let params = qs.stringify(this.tc_rule[key].queryParams);

            this.$http
                .get("/stage-api/ticket/rule/on/list?" + params)
                .then((res) => {
                    this.tc_rule[key].arr = res.rows;
                    this.tc_rule[key].queryParams.total = res.total;
                });
        },

        changePage(e, type) {
            if (type == 'tableData') {
                this.tableDataParams.pageNum = e;
                this.get_income_statistics()
                return
            }

            let { pageNum, teacherType } = e;
            this.tc_rule[teacherType].queryParams.pageNum = pageNum;

            let teacherType1 = [
                { label: '缩水师', key: 'sss' },
                { label: '技巧师', key: 'jqs' },
                { label: '软件师', key: 'rjs' },
            ]

            let label = teacherType1.filter(item => item.key == teacherType)[0].label

            this.getCommission_rules({
                label,
                value: this.queryTeacher(label),
                key: teacherType,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.shouru-tongji {
    padding: 20px;

    .card-header {
        background: #eee;
    }

    // 表格卡片
    .table-card {
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
        overflow: visible;
        margin-bottom: 20px;
        border: 1px solid #e2e8f0;

        .card-header {
            padding: 6px 20px;
            border-radius: 12px 12px 0 0;

            .header-left {
                display: flex;
                align-items: center;
                gap: 16px;
                flex-wrap: wrap;

                .header-title {
                    font-size: 16px;
                    font-weight: 600;
                    letter-spacing: 0.5px;
                    white-space: nowrap;
                }

                .lottery_menu {
                    display: flex;
                    gap: 8px;
                    flex-wrap: wrap;

                    >div {
                        padding: 6px 16px;
                        text-align: center;
                        cursor: pointer;
                        border-radius: 4px;
                        background: rgba(255, 255, 255, 0.15);
                        font-weight: 500;
                        font-size: 13px;
                        transition: all 0.3s ease;
                        backdrop-filter: blur(10px);

                        &:hover {
                            background: rgba(34, 149, 245, 0.25);
                        }

                        &.active {
                            background: linear-gradient(135deg, #E92728 0%, #dc2626 100%);
                            color: #fff;
                            box-shadow: 0 2px 8px rgba(233, 39, 40, 0.25);
                        }
                    }
                }
            }
        }

        :deep(.el-table) {
            --el-table-row-hover-bg-color: #f8fafc;
        }

        :deep(.el-table__row) {
            transition: background-color 0.2s ease;
        }
    }

    // 提成方案卡片
    .scheme-card {
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
        overflow: visible;
        margin-bottom: 20px;
        border: 1px solid #e2e8f0;

        .card-header {
            padding: 16px 20px;
            border-radius: 12px 12px 0 0;

            .header-title {
                font-size: 16px;
                font-weight: 600;
                letter-spacing: 0.5px;
            }
        }

        .sub-table-title {
            padding: 12px 20px;
            border-bottom: 1px solid #e2e8f0;
            background: #f8fafc;

            .title-tag {
                display: inline-block;
                padding: 4px 12px;
                border-radius: 4px;
                font-size: 13px;
                font-weight: 600;

                &.sss {
                    background: linear-gradient(135deg, #409eff 0%, #2d8cf0 100%);
                    color: #fff;
                }

                &.jqs {
                    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
                    color: #fff;
                }

                &.rjs {
                    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
                    color: #fff;
                }
            }
        }

        :deep(.el-table) {
            --el-table-row-hover-bg-color: #f8fafc;
        }

        :deep(.el-table__row) {
            transition: background-color 0.2s ease;
        }
    }
}
</style>